export const createReferencePropertyMtn = /* GraphQL */ `
  mutation CreateReferenceProperty($input: CreateReferencePropertyInput!) {
    createReferenceProperty(input: $input) {
      createdAt
    }
  }
`
export const updateReferencePropertyMtn = /* GraphQL */ `
  mutation UpdateReferenceProperty($input: UpdateReferencePropertyInput!) {
    updateReferenceProperty(input: $input) {
      updatedAt
    }
  }
`
export const deleteReferencePropertyMtn = /* GraphQL */ `
  mutation DeleteReferenceProperty($input: DeleteReferencePropertyInput!) {
    deleteReferenceProperty(input: $input) {
      updatedAt
    }
  }
`
export const listReferencePropertiesQry = /* GraphQL */ `
  query ListReferenceProperties(
    $filter: ModelReferencePropertyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listReferenceProperties(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        byUserID
        organizationID
        createdAt
        updatedAt
        status
        properties {
          key
          values
          type
        }
      }
      nextToken
    }
  }
`
export const referencesByOrganizationQry = /* GraphQL */ `
  query referencesByOrganization(
    $organizationID: ID!
    $filter: ModelReferencePropertyFilterInput
    $limit: Int
  ) {
    referencesByOrganization(
      organizationID: $organizationID
      filter: $filter
      limit: $limit
    ) {
      items {
        id
        byUserID
        organizationID
        createdAt
        updatedAt
        status
        properties {
          key
          values
          type
        }
      }
    }
  }
`
